var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoArrowTop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_22714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01528 3.33366C8.03694 3.3613 8.05564 3.39169 8.08027 3.41637C9.36093 4.70015 10.642 5.98348 11.9234 7.26659C11.9489 7.29217 11.9788 7.31342 12 7.33124C11.8208 7.51037 11.6525 7.67875 11.4814 7.84988C10.453 6.81946 9.41771 5.78197 8.366 4.72826V12.667H7.63537L7.63537 4.74356C6.58913 5.7918 5.55271 6.8302 4.52198 7.8629C4.34114 7.68218 4.17399 7.51539 3.99977 7.34153C4.01619 7.32416 4.04013 7.29811 4.06499 7.27321C5.34816 5.9876 6.63132 4.70198 7.91403 3.41591C7.93843 3.39146 7.95736 3.36107 7.97879 3.33366H8.01528Z",
    fill: "#0C9914"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_22714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9.333,
    fill: "#fff",
    transform: "rotate(180 6 6.333)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoArrowTop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_arrow_top.3bb1fca36ed6e674beea354343201986.svg";